import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static identifier: string;

  static setIdentifier(identifier: string) {
    this.identifier = identifier;
  }

  connect() {
    // Scroll to bottom on initial load
    this.scrollToBottom();
  }

  scrollToBottom() {
    // Use requestAnimationFrame to ensure the DOM has updated
    requestAnimationFrame(() => {
      this.element.scrollTop = this.element.scrollHeight;
    });
  }
}
